import React from "react";
import PropTypes from "prop-types";
import RatingEmoji from "./RatingEmoji";
import {
  RatingStepWrapper,
  Title,
  ReviewTitle,
  Rating,
  Input,
  Label,
  StepCount,
} from "../styles/form-steps-styles";

const RecommendStep = ({ setRating, rating, recruiterName, agencyName }) => (
  <RatingStepWrapper noPointerEvents={rating}>
    <Title data-test-id="step4-rating-title">
      Please leave a review for <strong>{recruiterName}</strong> at{" "}
      <strong>{agencyName}</strong>
    </Title>
    <RatingEmoji rating={rating} />
    <ReviewTitle
      className="animated fadeIn delay-1"
      data-test-id="step4-review-title"
    >
      Would you refer me to a friend?
      <br /> (1 = no, 5 = yes, definitely)
    </ReviewTitle>
    <Rating className="rating animated fadeIn delay-2">
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="recommendRating"
        id="rating-15"
        value={5}
        data-test-id="step-rating-input"
      />
      <Label htmlFor="rating-15" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="recommendRating"
        id="rating-14"
        value={4}
      />
      <Label htmlFor="rating-14" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="recommendRating"
        id="rating-13"
        value={3}
      />
      <Label htmlFor="rating-13" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="recommendRating"
        id="rating-12"
        value={2}
      />
      <Label htmlFor="rating-12" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="recommendRating"
        id="rating-11"
        value={1}
      />
      <Label htmlFor="rating-11" />
    </Rating>
    <StepCount data-test-id="step-count">step 4 of 5</StepCount>
  </RatingStepWrapper>
);

RecommendStep.propTypes = {
  setRating: PropTypes.func.isRequired,
  recruiterName: PropTypes.string.isRequired,
  agencyName: PropTypes.string.isRequired,
  rating: PropTypes.number,
};

RecommendStep.defaultProps = {
  rating: PropTypes.isNull,
};

export default RecommendStep;
